import { createApp } from "vue";
import FlipButton from "./FlipButton.vue";
import ResetButton from "./ResetButton.vue";
import ZoomButton from "./ZoomButton.vue";

document.querySelectorAll('[data-vue-root="designer-control-buttons"]').forEach(el => {
    const app = createApp({});
    app.component('flip-button', FlipButton);
    app.component('reset-button', ResetButton);
    app.component('zoom-button', ZoomButton);
    app.mount(el);
});
